import { render, staticRenderFns } from "./settle.vue?vue&type=template&id=255a4d84&scoped=true&"
import script from "./settle.vue?vue&type=script&lang=js&"
export * from "./settle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a4d84",
  null
  
)

export default component.exports